import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Card } from "react-md";
import { agentSearchByTerm } from "actions/agent";
import { phoneNumberFormatter } from "components/Shared/Formatters";
import { getSearchParameter } from "components/Shared/Functions";
import { CustomerAgentProfile } from ".";
import MGrid, {
  COL_CODE_EMAIL,
  ACTION_CONFIGURE,
  ACTION_REFRESH,
  ACTION_ADD,
  COL_CODE_FULL_NAME,
  FILTER_TYPE_MULTI_SELECT,
  FILTER_TYPE_TEXT
} from "components/Shared/MGrid.tsx";
import MSplitter from "components/Shared/MSplitter.tsx";
import { CUSTOMER_AGENT_CREATE } from "typeConstants/rights";

const gridCols = [
  {
    key: "id",
    name: "Id",
    dataSource: "id",
    visible: false
  },
  {
    key: "majorCompanyName",
    name: "Major Company",
    width: 170,
    dataSource: "majorCompanyName",
    resizable: true,
    filterType: FILTER_TYPE_MULTI_SELECT
  },
  {
    key: "agentCode",
    name: "Agent Code",
    width: 170,
    dataSource: "agentCode",
    resizable: true,
    filterType: FILTER_TYPE_TEXT
  },
  {
    code: COL_CODE_FULL_NAME,
    dataSource: "agentName",
    resizable: true,
    filterType: FILTER_TYPE_TEXT
  },
  {
    key: "phoneNumber",
    name: "Phone",
    width: 120,
    dataSource: "phoneNumber",
    resizable: true,
    valueFormatter: phoneNumberFormatter,
    filterType: FILTER_TYPE_TEXT
  },
  {
    key: "faxNumber",
    name: "Fax",
    width: 120,
    dataSource: "faxNumber",
    resizable: true,
    valueFormatter: phoneNumberFormatter,
    filterType: FILTER_TYPE_TEXT
  },
  {
    code: COL_CODE_EMAIL,
    dataSource: "emailAddress",
    resizable: true,
    filterType: FILTER_TYPE_TEXT
  },
  {
    key: "notificationMethod",
    name: "Notification Method",
    width: 160,
    dataSource: "notificationMethod",
    resizable: true,
    filterType: FILTER_TYPE_MULTI_SELECT
  }
];

class CustomerAgentList extends React.Component {
  constructor(props) {
    super(props);
    this.onRowClick = this.onRowClick.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.navigateToAgent = this.navigateToAgent.bind(this);
    this.getActions = this.getActions.bind(this);

    this.state = {
      agentId: null
    };
  }

  componentDidMount() {
    const { location, agentSearchByTerm } = this.props;
    agentSearchByTerm(getSearchParameter(location));
  }

  onRowClick(rowIndex) {
    this.setState({ agentId: this.props.agentList[rowIndex].id });
  }

  onCreate() {
    this.props.history.push({ pathname: "/customer-agent/create" });
  }

  navigateToAgent() {
    this.props.history.push({
      pathname: "/customer-agent/profile",
      state: {
        agentId: this.state.agentId
      }
    });
  }

  getActions() {
    let actions = [ACTION_CONFIGURE, ACTION_REFRESH];
    if (this.props.canCreate) actions.push({ code: ACTION_ADD, onClick: this.onCreate });
    return actions;
  }

  render() {
    return (
      <MSplitter
        firstChild={
          <div className="padding-page-content full-height">
            <div className="here" />
            <Card className="full-height">
              <MGrid
                configurationId="CustomerAgentList"
                headerText="Customer Agent List"
                columnDefinitions={gridCols}
                data={this.props.agentList}
                isFetchingData={this.props.isFetchingAgentList}
                actions={this.getActions()}
                onRowClick={this.onRowClick}
              />
            </Card>
          </div>}
        secondChild={
          this.state.agentId &&
          <CustomerAgentProfile agentId={this.state.agentId} verticalDisplay />}
        secondChildTitle={{
          title: "Customer Agent Profile",
          buttons: [
            { icon: "fullscreen", onClick: this.navigateToAgent },
            { icon: "close", onClick: () => this.setState({ agentId: null }) }
          ]
        }}
      />
    );
  }
}

CustomerAgentList.propTypes = {
  agentSearchByTerm: PropTypes.func.isRequired,
  isFetchingAgentList: PropTypes.bool.isRequired,
  agentList: PropTypes.array,
  location: PropTypes.object,
  history: PropTypes.object.isRequired,
  canCreate: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
  return {
    agentList: state.customer.agentList,
    isFetchingAgentList: state.customer.isFetchingAgentList,
    canCreate: state.user.profile.rights.includes(CUSTOMER_AGENT_CREATE),
  };
};

const mapDispatchToProps = dispatch => ({
  agentSearchByTerm(search) {
    dispatch(agentSearchByTerm(search));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CustomerAgentList));

